/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Formatter & Validator — Beautify / Minify | Toolverse`)
};

const es_jf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formateador y Validador JSON — Embellecer / Minificar | Toolverse`)
};

const de_jf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON-Formatter & Validator — Formatieren / Minimieren | Toolverse`)
};

const nl_jf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Formatter & Validator — Mooi maken / Minimaal | Toolverse`)
};

const fr_jf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formateur et validateur JSON — Embellir / Minifier | Toolverse`)
};

const it_jf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formattatore JSON e Validatore — Formatta / Minimizza | Toolverse`)
};

const pt_br2_jf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatador JSON e Validador — Embelezar / Minificar | Toolverse`)
};

const pt_jf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatador e Validador de JSON — Embelezar / Minificar | Toolverse`)
};

const ja_jf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONフォーマッター & バリデーター — beautify / minify | Toolverse`)
};

const zh_jf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 格式化与验证工具 — 美化 / 压缩 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jf_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jf_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jf_meta_title", locale)
	if (locale === "en") return en_jf_meta_title(inputs)
	if (locale === "es") return es_jf_meta_title(inputs)
	if (locale === "de") return de_jf_meta_title(inputs)
	if (locale === "nl") return nl_jf_meta_title(inputs)
	if (locale === "fr") return fr_jf_meta_title(inputs)
	if (locale === "it") return it_jf_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_jf_meta_title(inputs)
	if (locale === "pt") return pt_jf_meta_title(inputs)
	if (locale === "ja") return ja_jf_meta_title(inputs)
	return zh_jf_meta_title(inputs)
};